import { defineStore } from 'pinia'
import axios from 'axios'

/** Store auth data in LocalStorage to get them next time
 *  @param data {Object} Auth data used to log-in
 *  @return {Boolean} True if stored, false if not
 */
function storeToken(data) {
  try {
    window.localStorage.setItem('auth', JSON.stringify(data))
    return true
  } catch (err) {
    return false
  }
}

/** Retrieve auth data from LocalStorage
 *  @return {Object} Auth data used to log-in
 */
function getToken() {
  try {
    const gotten = window.localStorage.getItem('auth')

    if (gotten) {
      return JSON.parse(gotten)
    }

    return null
  } catch (err) {
    return null
  }
}

/** Remove auth data from LocalStorage
 *  @return {Boolean} True if removed, false if not
 */
function removeToken() {
  try {
    window.localStorage.removeItem('auth')
    return true
  } catch (e) {
    return false
  }
}

/** Set axios auth headers to enable following API Calls
 *  @param token  {String} Auth thoken to use as Bearer token
 */
function setAxiosHeaders(token) {
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` }
}

// ToDo @CodingCarlos: TAKE THIS OUT OF HERE TO MAKE IT GLOBALIZABLE
// Initial load data from LocalStorage
let initalAuthData = getToken()

if (!initalAuthData) {
  initalAuthData = {
    id: null,
    organization: null,
    token: null,
    refresh: null,
  }
} else if (initalAuthData.token) {
  setAxiosHeaders(initalAuthData.token)
}

export const useAuth = defineStore('auth', {
  state: () => ({
    isLoading: false,
    id: initalAuthData.id || null,
    organization: initalAuthData.organization || null,
    token: initalAuthData.token || null,
    refresh: initalAuthData.refresh || null,
    error: null,
  }),
  getters: {
    isLogged: (state) => !!state.token,
  },
  actions: {
    storeAuth({ token, refresh, id, organization, error }) {
      if (!token || error) {
        this.error = error || null
        this.logout()

        return false
      }

      this.isLoading = true

      this.id = id || null
      this.organization = organization || null
      this.token = token
      this.refresh = refresh || null

      // Set axios defaults
      setAxiosHeaders(token)

      // Store auth data
      storeToken({
        id,
        organization,
        token,
        refresh,
      })

      this.isLoading = false
      return false
    },
    updateTokenOrg(organization_id) {
      let token = getToken()
      //this could be an external function generateAuth() like in account.js if we reuse it
      let data = {
        token: token.token || '',
        refresh: token.refresh || '',
        id: token.id || '',
        organization: organization_id || null,
      }
      this.storeAuth(data)
    },

    logout() {
      this.id = null
      this.organization = null
      this.token = null
      this.refresh = null

      // Reset axios defaults
      axios.defaults.headers.common = { Authorization: `` }

      // Remove stored auth data
      removeToken()

      return true
    },
  },
})
